/*
      ___           ___
     /\  \         /\  \
    /::\  \       /::\  \
   /:/\:\  \     /:/\ \  \
  /::\ \:\  \   _\:\ \ \  \
 /:/\:\ \:\__\ /\ \:\ \ \__\
 \/_|::\/:/  / \:\ \:\ \/__/
    |:|::/  /   \:\ \:\__\
    |:|\/__/     \:\/:/  /
    |:|  |        \::/  /
     \|__|         \/__/

    Developed by Ralph Shippam - 2019.
*/

import {Injectable, ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RSLoadingDeactivateGuardService, RSLoadingHTTPInterceptor} from './rsloading.service';
import {RsloadingHttpComponent} from './rsloading.http.component';
import {RSloadingModalComponent} from './rsloading.modal.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {MatDialogModule} from '@angular/material/dialog';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatIconModule} from '@angular/material/icon';
import {WindowRef} from './windowref';
import {RSLoadingModalDefaults} from './rsloading.modal.defaults';
import {RSDialogModule} from '../rsnotify/rsdialog.module';
import {RSLoadingModalSpinkitComponent} from './rsloading.modal.spinkit.component';

// ADAPTED WITH THANKS FROM https://github.com/WoltersKluwerPL/ng-spin-kit
import { SpinnerComponent } from './spinkit/spinner.component';
import { RotatingPlaneComponent } from './spinkit/rotating-plane.component';
import { DoubleBounceComponent } from './spinkit/double-bounce.component';
import { WaveComponent } from './spinkit/wave.component';
import { WanderingCubesComponent } from './spinkit/wandering-cubes.component';
import { PulseComponent } from './spinkit/pulse.component';
import { ChasingDotsComponent } from './spinkit/chasing-dots.component';
import { CircleComponent } from './spinkit/circle.component';
import { ThreeBounceComponent } from './spinkit/three-bounce.component';
import { CubeGridComponent } from './spinkit/cube-grid.component';
import { WordPressComponent } from './spinkit/word-press.component';
import { FadingCircleComponent } from './spinkit/fading-circle.component';
import { FoldingCubeComponent } from './spinkit/folding-cube.component';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatIconModule,
        RSDialogModule
    ],
    exports: [
        RsloadingHttpComponent,

        // If we export these, others can use them? TODO:
        SpinnerComponent,
        RotatingPlaneComponent,
        DoubleBounceComponent,
        WaveComponent,
        WanderingCubesComponent,
        PulseComponent,
        ChasingDotsComponent,
        CircleComponent,
        ThreeBounceComponent,
        CubeGridComponent,
        WordPressComponent,
        FadingCircleComponent,
        FoldingCubeComponent,
        RSloadingModalComponent
    ],
    declarations: [
        RsloadingHttpComponent,
        RSloadingModalComponent,
        RSLoadingModalSpinkitComponent,

        SpinnerComponent,
        RotatingPlaneComponent,
        DoubleBounceComponent,
        WaveComponent,
        WanderingCubesComponent,
        PulseComponent,
        ChasingDotsComponent,
        CircleComponent,
        ThreeBounceComponent,
        CubeGridComponent,
        WordPressComponent,
        FadingCircleComponent,
        FoldingCubeComponent
    ],
    providers: [
        RSLoadingHTTPInterceptor,
        RSLoadingDeactivateGuardService,
        WindowRef
    ]
})
export class RSloadingModule {
    public static forRoot(configurationFactory: () => RSLoadingModalDefaults): ModuleWithProviders<RSloadingModule> {
        return {
            ngModule: RSloadingModule,
            providers: [ { provide: RSLoadingModalDefaults, useFactory: configurationFactory }, RSLoadingHTTPInterceptor ]
        };
    }
}
